export enum InvoiceType
{
    Purchase = 0,
    Credit = 1
}

export const InvoiceTypeMetadata = {
    '0': {
        display: 'Purchase',
        value: 0
    },
    '1': {
        display: 'Credit',
        value: 1
    }
}